import type { ProjectLogOut, ProjectOut } from "@/entities/projects/types";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/shared/ui/sheet";
import { ProjectLog } from "@/widgets/ProjectLog";
import { PipelineSteps } from "@/widgets/ProjectPage/PipelineSteps";

const TERMINAL = new Set(["done", "partial", "failed", "cancelled"]);

export interface CollectLogSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  project: ProjectOut;
  liveProgress: number;
  liveCurrentStep: string | null;
  liveStatus: string | null;
  liveLogs: ProjectLogOut[];
}

/**
 * Sheet справа с логом сбора. Открывается из ⋮ меню в шапке проекта.
 *
 * Раньше «Сбор» был отдельным табом, но при готовом проекте он становился
 * шумом — юзер хочет видеть кластеры, не лог. Теперь лог — second-class:
 * нужен — открой через меню.
 */
export function CollectLogSheet({
  open,
  onOpenChange,
  project,
  liveProgress,
  liveCurrentStep,
  liveStatus,
  liveLogs,
}: CollectLogSheetProps): JSX.Element {
  const status = liveStatus ?? project.status;
  const progress = TERMINAL.has(status)
    ? 100
    : Math.max(project.progress, liveProgress);
  const currentStep = liveCurrentStep ?? project.current_step;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="w-full border-l border-white/10 bg-background p-0 sm:max-w-[560px]"
      >
        <SheetHeader className="border-b border-white/10 px-5 py-4">
          <SheetTitle className="text-base font-bold text-white">
            Журнал сбора
          </SheetTitle>
          <SheetDescription>
            Этапы конвейера и лог в реальном времени. Полезно для отладки —
            если что-то странное в результатах, проверь сообщения здесь.
          </SheetDescription>
        </SheetHeader>

        <div className="space-y-4 overflow-y-auto p-5">
          <PipelineSteps
            currentStep={currentStep}
            progress={progress}
            done={TERMINAL.has(status)}
          />
          <ProjectLog
            entries={liveLogs}
            emptyText={
              status === "queued"
                ? "Ждём слот воркера…"
                : "Лог пуст"
            }
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}
